import { render } from "./FileComponent.vue?vue&type=template&id=1a23bb88&scoped=true"
import script from "./FileComponent.vue?vue&type=script&lang=js"
export * from "./FileComponent.vue?vue&type=script&lang=js"

import "./FileComponent.vue?vue&type=style&index=0&id=1a23bb88&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a23bb88"]])

export default __exports__